'use client';
import loadable from '@loadable/component';
import { type HTMLProps } from 'react';

import { ErrorBoundary } from '@/components/error-boundary';

import type { Maybe } from '@/generated/graphql';

type DynamicComponentProps = {
  icon: string;
  'data-testid'?: string;
  className?: HTMLProps<HTMLElement>['className'];
};

type ContentfulIconProps = {
  id: string | Maybe<string>;
  className?: HTMLProps<HTMLElement>['className'];
};

export const ContentfulIcon = ({ id, className }: ContentfulIconProps) => {
  if (!id) {
    return null;
  }
  const DynamicIcon = loadable(
    (props: DynamicComponentProps) =>
      import(`@energy-retailer/icons/components/${props.icon}.tsx`),
    {
      cacheKey: (props) => (props as DynamicComponentProps).icon,
    }
  );

  return (
    // Fallback to displaying the icon id if we don't have the corresponding icon in the codebase
    <ErrorBoundary fallback={<p>{id}</p>}>
      <DynamicIcon
        icon={id}
        data-testid={id}
        className={className}
      />
    </ErrorBoundary>
  );
};
